import * as React from "react";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActionsCreators } from "../../actions";
import strings from "../../helpers/Localization";

//CUSTOM COMPONENT
import Area from "../../aGlobalDesign/Area/Area";

import InvitationsList from "./Users/InvitationsList";
import UserGroupsList from "./UserGroups/UserGroupsList";
import UsersList from "./Users/UsersList";

class UsersContainer extends React.Component {

    constructor() {
        super();
        this.state = {
            reload: new URLSearchParams(new URL(window.location.href).search).get("reload"),
            createNew: 0,
            selectedPage: "users",
            reloadKey: 0
        };
    }

    componentDidMount() {
        this.props.toggleAdministrationMenu();
    }

    forcePaginationUpdate() {
        const temp = this.state.forcePaginationUpdate + 1;
        this.setState({
            selectedDisplay: null,
            forcePaginationUpdate: temp
        });
    }

    componentDidUpdate(prevProps) {
        const reload = new URLSearchParams(new URL(window.location.href).search).get("reload");
        if (reload && this.state.reload !== reload) {
            this.setState({ reload: reload });
            this.forcePaginationUpdate();
        }
    }

    getNavigationList() {
        const accessrights = this.props.currentuser && this.props.currentuser.accessrights ? this.props.currentuser.accessrights : null;
        const list = [];
        if (accessrights && accessrights.hasPermission(200, "consult") > 10) {
            list.push({
                id: "users",
                title: strings.Accounts,
                onSelect: () => this.setState(prev => ({
                    selectedPage: "users",
                    reloadKey: prev.reloadKey + 1
                }))
            });
        }
        if (accessrights && accessrights.hasPermission(100, "consult") > 10) {
            list.push({
                id: "roles",
                title: strings.userGroups,
                onSelect: () => this.setState(prev => ({
                    selectedPage: "roles",
                    reloadKey: prev.reloadKey + 1
                }))
            });
        }
        if (accessrights && accessrights.hasPermission(200, "create") > 10) {
            list.push({
                id: "invitations",
                title: strings.titleInvitations,
                onSelect: () => this.setState(prev => ({
                    selectedPage: "invitations",
                    reloadKey: prev.reloadKey + 1
                }))
            });
        }
        return list;
    }
    getSideButtonsList() {
        const accessrights = this.props.currentuser && this.props.currentuser.accessrights ? this.props.currentuser.accessrights : null;
        const sb = {
            type: "primary-icon",
            nameIcon: "add",
            text: strings.AddAccount,
            onClick: () => this.setState({ createNew: this.state.createNew + 1 })
        };
        if (this.state.selectedPage == "roles" && accessrights && accessrights.hasPermission(100, "create") <= 10) {return [];}
        if (this.state.selectedPage == "invitations" && accessrights && accessrights.hasPermission(200, "create") <= 10) {return [];}
        if (this.state.selectedPage == "users") {return [];}
        return [sb];
    }



    render() {
        const accessrights = this.props.currentuser && this.props.currentuser.accessrights ? this.props.currentuser.accessrights : null;

        return <>
            <Area
                helmet={strings.helmetUserList}
                title={strings.usersAndRoles}
                navigatedId={this.state.selectedPage}
                navigation={this.getNavigationList()}
                sideButtons={this.getSideButtonsList()}
            >
                {
                    this.state.selectedPage == "roles" ? <UserGroupsList
                        reload={this.state.reload}
                        key={`roles-${this.state.reloadKey}`}
                        createNew={this.state.createNew}
                    /> : null
                }
                {
                    this.state.selectedPage == "invitations" ? <InvitationsList
                        reload={this.state.reload}
                        key={`invitations-${this.state.reloadKey}`}
                        createNew={this.state.createNew}
                    /> : null
                }
                {
                    this.state.selectedPage == "users" ? <UsersList
                        reload={this.state.reload}
                        key={`users-${this.state.reloadKey}`}
                        createNew={this.state.createNew}
                    /> : null
                }
            </Area>
        </>;
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(ActionsCreators, dispatch);
};

export default withRouter(connect(
    (state) => state,
    mapDispatchToProps
)(UsersContainer));
